import { MdAttachFile, MdOutlineFileDownload } from "react-icons/md";

const Item = ({ name, size, onDownload }) => {
  return (
    <div className="amellis__documents">
      <MdAttachFile className="amellis__documents--icon" size={24} />
      <div className="amellis__documents--content">
        <div className="amellis__documents--content--name">
          {name} <span>{`.pdf`}</span>
        </div>
        <div className="amellis__documents--content--size">{size}</div>
      </div>
      <div className="amellis__documents--action" onClick={onDownload}>
        <MdOutlineFileDownload size={20} />
      </div>
    </div>
  );
};
export default Item;
